import { render, staticRenderFns } from "./IconFilter.vue?vue&type=template&id=2b900c7b"
import script from "./IconFilter.vue?vue&type=script&lang=js"
export * from "./IconFilter.vue?vue&type=script&lang=js"
import style0 from "./IconFilter.vue?vue&type=style&index=0&id=2b900c7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports